import emitter from '../emitter'

import config from '../config'

class mediator {

    constructor(enforcer) {

       this.emitter = emitter

       this.now = Date.now()

      
    }

    update() {

        let tempnow = Date.now()

        let delta = ( Date.now() - this.now) / 1000

        this.now = tempnow

        this.absTimer += delta

        this.emitter.emit('update', delta)
        
        this.emitter.emit('postupdate')


            function onMouseMove( e ) {

                mouse.x = e.clientX;
                mouse.y = e.clientY;

            }


    }

    addEvents() {


        if(config.touchDevice == false){

            window.addEventListener('mousemove', this.mousemove.bind(this))
        }

        window.addEventListener('resize', this.onResize.bind(this))

    }

    mousemove(e){

        emitter.emit('mousemove', e)

    }

    onResize(e) {

        this.resize()

    }

    resize(){

        this.h = config.container.clientHeight

        this.w = config.container.clientWidth

        this.emitter.emit('resize', this.w, this.h)

    }

}

export default new mediator()



// WEBPACK FOOTER //
// ./src/scripts/Trail/globals/mediator.js